module.exports = __webpack_public_path__ + "media/images/logo-1d44bc97971dfdb8b19327dfccaf3387.svg";